/**
 * @param {HTMLInputElement} input
 * @return {string}
 */
import {getDutchFormat, reverseDateFormat, stringIsValidDate} from '@/utils/dateHelper';

const getDateValidation = (input) => {
	/**
	 * FIXME things to improve
	 * - Prevent entering of characters other than numbers and separators
	 * - auto convert separators
	 */

	const value = input.value;

	const valueRevertedToNormal = reverseDateFormat(value);
	const valueAsDate = new Date(valueRevertedToNormal);

	if (value.length === 0 && !input.required) {
		return '';
	}

	if (value.length === 0 && input.required) {
		return 'Dit is een verplicht veld';
	}

	if (valueRevertedToNormal.length !== 10 || !stringIsValidDate) {
		return 'Geen geldige datum (dd-mm-jjjj)';
	}

	const min = input.getAttribute('min');
	const max = input.getAttribute('max');

	const minDate = min ? new Date(min) : null;
	const maxDate = max ? new Date(max) : null;

	const isBeforeMin = min ? valueAsDate < minDate : false;
	const isAfterMax = max ? valueAsDate > maxDate : false;

	if (minDate && maxDate && (isBeforeMin || isAfterMax)) {
		return `Datum mag niet voor ${getDutchFormat(minDate)} en niet na ${getDutchFormat(maxDate)} liggen`;
	}

	if (isBeforeMin) {
		return `Datum mag niet voor ${getDutchFormat(minDate)} liggen`;
	}

	if (isAfterMax) {
		return `Datum mag niet na ${getDutchFormat(maxDate)} liggen`;
	}

	return '';
};

/**
 * @param {HTMLInputElement} input
 * @return {string}
 */
export const getCustomValidationMessage = (input) => {
	const validityState = input.validity;

	if (input.classList.contains('js-datepicker')) {
		const dateMessage = getDateValidation(input);
		if (dateMessage.length > 0) {
			return dateMessage;
		}
	}

	if (validityState.valid) {
		return '';
	}

	if (validityState.valueMissing) {
		return 'Dit is een verplicht veld';
	}
	if (validityState.tooShort) {
		return `Vul hier minimaal ${input.getAttribute('minlength')} tekens in.`;
	}
	if (validityState.tooLong) {
		input.setCustomValidity(`Vul hier maximaal ${input.getAttribute('maxlength')} tekens in.`);
	}
	if (validityState.patternMismatch) {
		const customMessage = input.dataset.patternMessage;
		if (customMessage) {
			return customMessage;
		}
	}
	return '';
};
